import React, {Component} from 'react';
import '../App.css';

export default class FlightResult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            local: this.props.local,
        };
    }

    handleDateString(str) {
        return new Date(parseInt(str + '000', 10)).toLocaleString(this.state.local);
    }

    render() {
        return (
            <div>
                <span>Departure airport: {this.props.data.flyFrom}</span>
                <span>Destination airport: {this.props.data.flyTo}</span>
                {this.props.data.route.length > 1 ?
                    <span>Route ({this.props.data.route.length} flights): {this.props.data.flyFrom}{this.props.data.route.map(o => {
                        return (' => ' + o.flyTo + ' (' + o.airline + ')')
                    })}</span> : <span>Airlines: {this.props.data.route[0].airline}</span>}
                <span>Departure time: {this.handleDateString(this.props.data.dTime)}</span>
                <span>Arrival time: {this.handleDateString(this.props.data.aTime)}</span>
                <span>Duration: {this.props.data.fly_duration}</span>
                <span>Price: {this.props.data.price} €</span>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/flightResult.js